/**
 * PERSONA 5 ROYAL PRODUCT PAGE INTERACTION ENGINE
 * Syncs horizontal gallery scrollbar, pill variant chips, PDP quantity, & AJAX add-to-cart.
 */

(function () {
  'use strict';

  var P5RProduct = {
    init: function () {
      this.bindScrollbarSync();
      this.bindImageZoom();
      this.bindPillVariants();
      this.bindQuantity();
      this.bindAddToCart();
      this.bindSizeChartModal();
    },

    bindScrollbarSync: function () {
      var track = document.getElementById('p5rPdpGalleryTrack');
      var bar = document.getElementById('p5rPdpCustomScrollbar');
      var thumb = document.getElementById('p5rPdpScrollThumb');
      if (!track || !bar || !thumb) return;

      var updateThumb = function () {
        var scrollLeft = track.scrollLeft;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          thumb.style.left = '0px';
          thumb.style.width = '100%';
          return;
        }
        var thumbWidthPercent = (track.clientWidth / track.scrollWidth) * 100;
        var minWidthPercent = Math.max(15, thumbWidthPercent);
        thumb.style.width = minWidthPercent + '%';

        var usableBarWidth = bar.clientWidth - thumb.clientWidth;
        if (usableBarWidth <= 0) {
          thumb.style.left = '0px';
          return;
        }
        var scrollRatio = Math.max(0, Math.min(1, scrollLeft / maxScroll));
        thumb.style.left = (scrollRatio * usableBarWidth) + 'px';
      };

      track.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb, { passive: true });
      updateThumb();

      // Precision Mouse Dragging Engine
      var isDragging = false;
      var startX = 0;
      var startScrollLeft = 0;

      var onMouseDown = function (e) {
        isDragging = true;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        thumb.style.cursor = 'grabbing';
        document.body.style.userSelect = 'none';

        var maxScroll = track.scrollWidth - track.clientWidth;
        var usableBarWidth = bar.clientWidth - thumb.clientWidth;

        // If click was outside thumb on the bar track, jump thumb center to cursor
        if (e.target !== thumb && usableBarWidth > 0 && maxScroll > 0) {
          var rect = bar.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          var targetLeft = clickX - (thumb.clientWidth / 2);
          var ratio = Math.max(0, Math.min(1, targetLeft / usableBarWidth));
          track.scrollLeft = ratio * maxScroll;
          startScrollLeft = track.scrollLeft;
        }
      };

      bar.addEventListener('mousedown', onMouseDown);

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var maxScroll = track.scrollWidth - track.clientWidth;
        var usableBarWidth = bar.clientWidth - thumb.clientWidth;
        if (maxScroll <= 0 || usableBarWidth <= 0) return;

        var deltaX = e.clientX - startX;
        var scrollDelta = (deltaX / usableBarWidth) * maxScroll;
        track.scrollLeft = startScrollLeft + scrollDelta;
      });

      document.addEventListener('mouseup', function () {
        if (isDragging) {
          isDragging = false;
          thumb.style.cursor = 'grab';
          document.body.style.userSelect = '';
        }
      });

      // Play 2-beat nudge hint animation 0.5s after page load
      setTimeout(function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll > 10 && !isDragging && track.scrollLeft < 5) {
          thumb.classList.add('has-nudge-hint');
          setTimeout(function () {
            thumb.classList.remove('has-nudge-hint');
          }, 850);
        }
      }, 500);
    },

    bindImageZoom: function () {
      var track = document.getElementById('p5rPdpGalleryTrack');
      var slides = document.querySelectorAll('.p5r-pdp-gallery-slide');
      if (!slides.length) return;

      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;

        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });

        var isZoomed = false;
        var zoomSrc = slide.getAttribute('data-zoom-src');

        // Preload master original resolution image on hover for instant seamless zoom
        slide.addEventListener('mouseenter', function () {
          if (zoomSrc && !slide.dataset.preloaded) {
            var preloadImg = new Image();
            preloadImg.src = zoomSrc;
            slide.dataset.preloaded = 'true';
          }
        });

        var updateTransformOrigin = function (clientX, clientY) {
          if (!isZoomed) return;
          var rect = slide.getBoundingClientRect();
          var xPercent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
          var yPercent = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));
          img.style.transformOrigin = xPercent + '% ' + yPercent + '%';
        };

        var snapSlideToFrame = function () {
          if (track) {
            track.scrollLeft = slide.offsetLeft;
          }
        };

        var enableMasterResolution = function () {
          if (!zoomSrc) return;
          if (!img.dataset.origSrc) {
            img.dataset.origSrc = img.src;
          }
          if (img.getAttribute('srcset') && !img.dataset.origSrcset) {
            img.dataset.origSrcset = img.getAttribute('srcset');
          }

          var masterImg = new Image();
          masterImg.onload = function () {
            if (isZoomed) {
              img.removeAttribute('srcset');
              img.src = zoomSrc;
            }
          };
          masterImg.src = zoomSrc;

          if (masterImg.complete) {
            img.removeAttribute('srcset');
            img.src = zoomSrc;
          }
        };

        var restoreNormalResolution = function () {
          if (img.dataset.origSrcset) {
            img.setAttribute('srcset', img.dataset.origSrcset);
          }
          if (img.dataset.origSrc) {
            img.src = img.dataset.origSrc;
          }
        };

        var toggleZoom = function (clientX, clientY) {
          // Disable custom click-to-pan zoom on mobile to prevent getting trapped and allow smooth swiping
          if (window.innerWidth <= 900) return;

          isZoomed = !isZoomed;
          if (isZoomed) {
            snapSlideToFrame();
            if (track) track.style.overflowX = 'hidden';
            enableMasterResolution();
            slide.classList.add('is-zoomed');
            updateTransformOrigin(clientX, clientY);
          } else {
            if (track) track.style.overflowX = 'auto';
            slide.classList.remove('is-zoomed');
            restoreNormalResolution();
            img.style.transformOrigin = 'center center';
          }
        };

        slide.addEventListener('click', function (e) {
          toggleZoom(e.clientX, e.clientY);
        });

        slide.addEventListener('mousemove', function (e) {
          if (isZoomed && window.innerWidth > 900) {
            updateTransformOrigin(e.clientX, e.clientY);
          }
        });

        slide.addEventListener('mouseleave', function () {
          if (isZoomed) {
            isZoomed = false;
            if (track) track.style.overflowX = 'auto';
            slide.classList.remove('is-zoomed');
            restoreNormalResolution();
            img.style.transformOrigin = 'center center';
          }
        });

        // Touch Interaction on Mobile
        slide.addEventListener('touchstart', function (e) {
          // Disable aggressive touch transform updates on mobile to prevent jittering while swiping
          if (window.innerWidth <= 900) return;
          
          if (e.touches.length === 1) {
            var touch = e.touches[0];
            updateTransformOrigin(touch.clientX, touch.clientY);
          }
        }, { passive: true });
      });
    },

    formatMoney: function (cents, format) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      var formatString = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : '${{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = formatString.match(placeholderRegex);
      if (!match) {
        return '$' + (cents / 100).toFixed(2);
      }

      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsFormatted = parts[1] ? (decimal + parts[1]) : '';

        return dollars + centsFormatted;
      }

      var value = '';
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },

    getVariantsData: function () {
      var script = document.getElementById('p5rProductVariantsJson');
      if (script) {
        try {
          return JSON.parse(script.textContent);
        } catch (e) {
          console.error('[P5R Product] Failed to parse variants JSON', e);
        }
      }
      return [];
    },

    bindPillVariants: function () {
      var self = this;
      var buttons = document.querySelectorAll('.p5r-pdp-variant-btn');
      var variantInput = document.getElementById('p5rSelectedVariantId');
      var variants = this.getVariantsData();
      if (!buttons.length || !variantInput) return;

      var updateSelectedVariant = function () {
        var groups = document.querySelectorAll('.p5r-pdp-variant-group');
        var selectedOptions = {};

        groups.forEach(function (group) {
          var activeBtn = group.querySelector('.p5r-pdp-variant-btn.is-active');
          if (activeBtn) {
            var pos = activeBtn.getAttribute('data-option-position') || group.getAttribute('data-option-position') || '1';
            selectedOptions['option' + pos] = activeBtn.getAttribute('data-option-value');
          }
        });

        if (!variants || !variants.length) return;

        var matchedVariant = variants.find(function (v) {
          var opt1Match = !selectedOptions.option1 || v.option1 === selectedOptions.option1;
          var opt2Match = !selectedOptions.option2 || v.option2 === selectedOptions.option2;
          var opt3Match = !selectedOptions.option3 || v.option3 === selectedOptions.option3;
          return opt1Match && opt2Match && opt3Match;
        });

        var addBtn = document.getElementById('p5rAddToCartBtn');
        var btnTextElem = addBtn ? addBtn.querySelector('.p5r-pdp-btn-text') : null;
        var priceContainer = document.getElementById('p5rProductPrice');

        if (matchedVariant) {
          variantInput.value = matchedVariant.id;

          // Update Price & Compare Price display
          if (priceContainer) {
            var priceFormatted = self.formatMoney(matchedVariant.price);
            var priceHtml = '<span class="p5r-pdp-price">' + priceFormatted + '</span>';
            if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
              var compareFormatted = self.formatMoney(matchedVariant.compare_at_price);
              priceHtml += ' <s class="p5r-pdp-compare-price">' + compareFormatted + '</s>';
              priceHtml += ' <span class="p5r-pdp-sale-badge">SALE</span>';
            }
            priceContainer.innerHTML = priceHtml;
          }

          // Update Add to Cart Button state
          if (addBtn && btnTextElem) {
            if (matchedVariant.available) {
              addBtn.disabled = false;
              btnTextElem.textContent = '[+] ADD TO CART';
            } else {
              addBtn.disabled = true;
              btnTextElem.textContent = 'SOLD OUT';
            }
          }

          // Update URL without page reload
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', matchedVariant.id);
            window.history.replaceState({ path: url.href }, '', url.href);
          }

          // Slide Gallery to Variant Media if assigned
          if (matchedVariant.featured_media && matchedVariant.featured_media.id) {
            var targetSlide = document.querySelector('.p5r-pdp-gallery-slide[data-media-id="' + matchedVariant.featured_media.id + '"]');
            var galleryTrack = document.getElementById('p5rPdpGalleryTrack');
            if (targetSlide && galleryTrack) {
              galleryTrack.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: 'smooth'
              });
            }
          }
        } else {
          // Combination unavailable
          if (addBtn && btnTextElem) {
            addBtn.disabled = true;
            btnTextElem.textContent = 'UNAVAILABLE';
          }
        }
      };

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parentGroup = btn.closest('.p5r-pdp-variant-options');
          var pos = btn.getAttribute('data-option-position');
          var val = btn.getAttribute('data-option-value');

          if (parentGroup) {
            parentGroup.querySelectorAll('.p5r-pdp-variant-btn').forEach(function (c) {
              c.classList.remove('is-active');
            });
          }
          btn.classList.add('is-active');

          var labelDisplay = document.getElementById('p5rSelectedOptionVal-' + pos);
          if (labelDisplay && val) {
            labelDisplay.textContent = val;
          }

          updateSelectedVariant();
        });
      });
    },

    bindQuantity: function () {
      var minusBtn = document.querySelector('.p5r-pdp-qty-minus');
      var plusBtn = document.querySelector('.p5r-pdp-qty-plus');
      var qtyVal = document.getElementById('p5rPdpQtyVal');
      var qtyInput = document.getElementById('p5rPdpQtyInput');

      if (!minusBtn || !plusBtn || !qtyVal || !qtyInput) return;

      minusBtn.addEventListener('click', function () {
        var curr = parseInt(qtyInput.value, 10) || 1;
        var next = Math.max(1, curr - 1);
        qtyInput.value = next;
        qtyVal.textContent = next;
      });

      plusBtn.addEventListener('click', function () {
        var curr = parseInt(qtyInput.value, 10) || 1;
        var next = curr + 1;
        qtyInput.value = next;
        qtyVal.textContent = next;
      });
    },

    bindAddToCart: function () {
      var self = this;
      var form = document.getElementById('p5rProductForm');
      var addBtn = document.getElementById('p5rAddToCartBtn');
      var variantInput = document.getElementById('p5rSelectedVariantId');
      if (!form || !addBtn) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var variantId = variantInput ? variantInput.value : form.querySelector('input[name="id"]')?.value;
        if (!variantId) return;

        var qtyInput = document.getElementById('p5rPdpQtyInput');
        var qtyVal = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        var btnTextElem = addBtn.querySelector('.p5r-pdp-btn-text');
        var originalText = btnTextElem ? btnTextElem.textContent : '[+] ADD TO CART';

        // Extract title, variant details, and quantity for notification
        var titleElem = document.querySelector('.p5r-pdp-editorial-title');
        var itemTitle = titleElem ? titleElem.textContent.trim() : 'ITEM';

        var activeOptions = [];
        document.querySelectorAll('.p5r-pdp-variant-btn.is-active').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          if (val) activeOptions.push(val);
        });
        var variantDetailsStr = activeOptions.join(' : ');

        addBtn.disabled = true;
        if (btnTextElem) btnTextElem.textContent = 'ADDING...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: qtyVal
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (errData) { throw errData; });
            }
            return res.json();
          })
          .then(function (data) {
            addBtn.disabled = false;
            if (btnTextElem) btnTextElem.textContent = 'ADDED!';

            // Trigger P5R In-Game HUD Toast Notification
            self.showP5RToast(itemTitle, variantDetailsStr, qtyVal);

            // Fetch updated cart details and update badges in background (without opening drawer)
            if (window.P5RCart && typeof window.P5RCart.fetchCartData === 'function') {
              window.P5RCart.fetchCartData();
            } else {
              fetch(window.Shopify.routes.root + 'cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  var badges = document.querySelectorAll('.p5r-hud-cart-badge, .p5r-hdr-cart-badge, [data-cart-count]');
                  badges.forEach(function (badge) {
                    badge.textContent = cart.item_count;
                    if (cart.item_count === 0) {
                      badge.classList.add('is-empty');
                    } else {
                      badge.classList.remove('is-empty');
                    }
                  });
                })
                .catch(function (e) {
                  console.error('[P5R Product] Error fetching updated cart:', e);
                });
            }

            setTimeout(function () {
              if (btnTextElem) btnTextElem.textContent = originalText;
            }, 2000);
          })
          .catch(function (err) {
            console.error('[P5R Product] Add to cart error:', err);
            addBtn.disabled = false;
            if (btnTextElem) {
              btnTextElem.textContent = (err && err.description) ? err.description.toUpperCase() : originalText;
            }
            setTimeout(function () {
              if (btnTextElem) btnTextElem.textContent = originalText;
            }, 3000);
          });
      });
    },

    showP5RToast: function (title, variantDetails, qty) {
      if (window.P5RToastSettings && window.P5RToastSettings.enabled === false) return;

      var container = document.getElementById('p5rToastContainer');
      if (!container) {
        container = document.createElement('div');
        container.id = 'p5rToastContainer';
        container.className = 'p5r-toast-container';
        document.body.appendChild(container);
      }

      var toast = document.createElement('div');
      toast.className = 'p5r-pdp-toast';

      var headerTag = (window.P5RToastSettings && window.P5RToastSettings.headerTag) ? window.P5RToastSettings.headerTag : '// SYSTEM NOTIFICATION // ITEM OBTAINED';
      var statusText = (window.P5RToastSettings && window.P5RToastSettings.statusText) ? window.P5RToastSettings.statusText : 'P5R_OK';
      var duration = (window.P5RToastSettings && window.P5RToastSettings.duration) ? window.P5RToastSettings.duration : 4000;

      var detailPart = variantDetails ? ' // ' + variantDetails : '';
      var qtyPart = ' x' + (qty || 1);

      var svgBg = '<svg class="p5r-toast-svg-frame" viewBox="0 0 141.7 51.3" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><g><polygon fill="#f2f2f2" points="141.5 .4 138.2 11.3 136.7 11 135.8 17.4 138.8 50.9 1.6 50.9 2.4 47.7 .2 48.4 6.1 3.9 126.5 3.9 131.5 3.8 135.5 2.9 138 3.8 141.5 .4"/><polygon fill="#050505" points="140.7 1.3 137.4 11.8 135.9 11.6 135 17.7 138 50.1 2.7 50.1 3.6 46.9 1.3 47.7 7.1 4.6 125.9 4.6 130.8 4.5 134.7 3.7 137.2 4.6 140.7 1.3"/></g></svg>';

      toast.innerHTML =
        svgBg +
        '<div class="p5r-toast-inner-content">' +
          '<div class="p5r-toast-header">' +
            '<span class="p5r-toast-tag">' + headerTag + '</span>' +
            '<span class="p5r-toast-status">' + statusText + '</span>' +
          '</div>' +
          '<div class="p5r-toast-body">' +
            '<div class="p5r-toast-icon">★</div>' +
            '<div class="p5r-toast-content">' +
              '<div class="p5r-toast-title">ADDED ' + title + '</div>' +
              '<div class="p5r-toast-details">' + detailPart + qtyPart + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      container.appendChild(toast);

      // Play P5R synthesized RPG item pickup chime sound if enabled
      if (!window.P5RToastSettings || window.P5RToastSettings.soundEnabled !== false) {
        this.playItemChime();
      }

      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });

      setTimeout(function () {
        toast.classList.remove('is-visible');
        toast.classList.add('is-dismissing');
        setTimeout(function () {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, 500);
      }, duration);
    },

    audioCtx: null,

    playItemChime: function () {
      try {
        var AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        if (!this.audioCtx) {
          this.audioCtx = new AudioCtx();
        }
        var ctx = this.audioCtx;
        if (ctx.state === 'suspended') {
          ctx.resume();
        }
        var osc1 = ctx.createOscillator();
        var osc2 = ctx.createOscillator();
        var gain = ctx.createGain();

        osc1.type = 'sine';
        osc2.type = 'triangle';

        var now = ctx.currentTime;
        osc1.frequency.setValueAtTime(587.33, now); // D5
        osc1.frequency.exponentialRampToValueAtTime(1174.66, now + 0.15); // D6

        osc2.frequency.setValueAtTime(880, now); // A5
        osc2.frequency.exponentialRampToValueAtTime(1760, now + 0.15); // A6

        gain.gain.setValueAtTime(0.15, now);
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);

        osc1.connect(gain);
        osc2.connect(gain);
        gain.connect(ctx.destination);

        osc1.start(now);
        osc2.start(now);
        osc1.stop(now + 0.35);
        osc2.stop(now + 0.35);
      } catch (e) {
        // Audio API fallback
      }
    },

    bindSizeChartModal: function () {
      var trigger = document.getElementById('p5rSizeChartBtn');
      var modal = document.getElementById('p5rSizeChartModal');
      var backdrop = document.getElementById('p5rSizeModalBackdrop');
      var closeBtn = document.getElementById('p5rSizeModalClose');

      if (!trigger || !modal) return;

      var openModal = function (e) {
        if (e) e.preventDefault();
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        if (closeBtn) closeBtn.focus();
      };

      var closeModal = function () {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        if (trigger) trigger.focus();
      };

      trigger.addEventListener('click', openModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-active')) return;

        if (e.key === 'Escape') {
          closeModal();
          return;
        }

        if (e.key === 'Tab') {
          var focusable = modal.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
          if (focusable.length === 0) return;
          
          var first = focusable[0];
          var last = focusable[focusable.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }
  };

  window.showP5RToast = function (title, variantDetails, qty) {
    P5RProduct.showP5RToast(title, variantDetails, qty);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { P5RProduct.init(); });
  } else {
    P5RProduct.init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId === 'product') {
      P5RProduct.init();
    }
  });
})();
